const MAX_ERRORS = 50;
let errors = [];

const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

function capture(level, args) {
  const msg = args.map(a => {
    if (a instanceof Error) return `${a.name}: ${a.message}`;
    if (typeof a === 'object') {
      try { return JSON.stringify(a).slice(0, 300); } catch { return String(a); }
    }
    return String(a);
  }).join(' ');
  errors.push({ level, message: msg.slice(0, 500), timestamp: new Date().toISOString() });
  if (errors.length > MAX_ERRORS) errors.shift();
}

console.error = function (...args) {
  capture('error', args);
  originalConsoleError.apply(console, args);
};

console.warn = function (...args) {
  capture('warn', args);
  originalConsoleWarn.apply(console, args);
};

window.addEventListener('error', (e) => {
  capture('error', [`Uncaught: ${e.message} at ${e.filename}:${e.lineno}`]);
});

window.addEventListener('unhandledrejection', (e) => {
  capture('error', [`Unhandled Promise: ${e.reason}`]);
});

export function getRecentErrors() {
  return errors.map(e => `[${e.level}] ${e.message}`);
}

export function clearErrors() {
  errors = [];
}
